module.exports = __webpack_public_path__ + "src/assets/img/share/7472b96c44131a83571ecd73ee61ea99.jpg";